import { createContext } from "react";

/**
 * Overrides how DateTimePicker displays date/time values.
 *
 * When no provider is present (the normal Viedoc Me flow) the value is null
 * and dates are formatted with the browser/device locale. The /pdf route
 * provides the study's date/time patterns from the Admin study settings
 * ({ datePattern, timePattern, dateTimePattern }, .NET format strings) so
 * that generated PDFs match the format configured for the study.
 */
export const DateDisplayFormatContext = createContext(null);
